import { StageCandidateActionType } from 'enums/stageAction';
import { SupportedLocale } from 'generated/graphql';

const translationAvailable = [
  StageCandidateActionType.PersonalityTest,
  StageCandidateActionType.CognitiveInductiveTest,
  StageCandidateActionType.DeiForm,
];

export const hasLanguageDisclaimer = (
  locale: SupportedLocale,
  actions: StageCandidateActionType[]
) => {
  if (locale === SupportedLocale.English) {
    return false;
  }
  const allActionsHaveTranslations = actions.every(action =>
    translationAvailable.includes(action)
  );

  if (allActionsHaveTranslations) {
    return false;
  }

  return true;
};
